import { render, staticRenderFns } from "./WicLogo.vue?vue&type=template&id=6662f837&"
import script from "./WicLogo.vue?vue&type=script&lang=js&"
export * from "./WicLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports